import React from "react";
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import { FolderOpen, Archive } from "lucide-react";

export default function Header() {
    const { t } = useTranslation();

    function setClass(isActive) {
        if (isActive)
            return "custom-nav-link active";
        else 
            return "custom-nav-link";
    }

    return (
        <Navbar id="custom-header" expand="lg">
            <Container fluid>                
                <Navbar.Collapse className="justify-content-center">
                    <Nav>
                        <NavLink className={({ isActive }) => setClass(isActive)} to={"/"}>
                            <FolderOpen className="me-2" /> Dossier
                        </NavLink>
                        <NavLink className={({ isActive }) => setClass(isActive)} to={"/archive"}>
                            <Archive className="me-2" />
                            {t("word.archives")}                            
                        </NavLink>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}